import Vue from 'vue'
import App from './App.vue'
import VueParticles from 'vue-particles'
import router from '@/router'

//import echarts from 'echarts/lib/echarts';
//Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false
Vue.use(VueParticles)

new Vue({
  router, // 使用router选项
  render: h => h(App),
}).$mount('#app')
